import JSEncrypt from 'jsencrypt';
export function encryptStr() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var RSA_KEY_BASE64 = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDSovT1rrwzrGoMCFb6z8e+5lzVdAD5o8krGIwdfxrVE2OnMijUZdkQk7etPJvZ2JOVXghthAGUUJkDUE8n2ZMNFKPjMrQJI49ewVzqWOKOvgU6Iu60Sn0xpeietP1wWXBkszdV1WfNBJUo2hhPDnIPMGzzdfLW5rMu+tczeUriJQIDAQAB';
  var jse = new JSEncrypt({});
  jse.setPublicKey("-----BEGIN PUBLIC KEY-----\n".concat(RSA_KEY_BASE64, "\n-----END PUBLIC KEY-----"));
  var result = jse.encrypt(str);
  return result;
}